<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/targetResponsibility/rectifyTarget' }">目标整改</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.params.id ? "编辑" : "新增" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="innerBox content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm formBox"
        size="small"
      >
        <el-form-item label="指标编号" prop="indicatorNumber">
          <el-input v-model="ruleForm.indicatorNumber" disabled />
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="整改部门" prop="abarbeitungDepId">
              <el-select v-model="ruleForm.abarbeitungDepId" placeholder="请选择" disabled style="width: 100%">
                <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="整改负责人" prop="abarbeitungDutyEmpId">
              <el-select v-model="ruleForm.abarbeitungDutyEmpId" placeholder="请选择考核部门" style="width: 100%">
                <el-option v-for="item in userList2" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="整改期限" prop="abarbeitungCompletionTime">
              <el-date-picker
                v-model="ruleForm.abarbeitungCompletionTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期时间"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="复核部门" prop="reCheckDepId">
              <el-select v-model="ruleForm.reCheckDepId" placeholder="请选择考核人" style="width: 100%" @change="departChange">
                <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item label="复核负责人" prop="reCheckEmpId">
              <el-select v-model="ruleForm.reCheckEmpId" placeholder="请选择复核负责人" style="width: 100%" @change="user($event, 1)">
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="整改内容" prop="abarbeitungContent">
          <el-input type="textarea" :rows="3" v-model="ruleForm.abarbeitungContent" placeholder="请输入考核内容" />
        </el-form-item>
        <el-form-item label="附件" prop="file">
          <el-upload
            class="upload-demo"
            action="/v1/certificate/uploadFile"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="postscript">
          <el-input v-model="ruleForm.postscript" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item prop="definitionId" label="流程模板" v-if="!$route.params.id">
          <el-select :disabled="$route.params.id ? true : false" v-model="ruleForm.definitionId"
          placeholder="请添加" style="width:100%" @change="modelChange">
            <el-option
              v-for="m in modules"
              :key="m.id"
              :label="m.name"
              :value="m.definitionId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" style="width: 100%">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getGoalAddData, getAllDepartment,
  getDepartUser, rectifyTargetSave, getStaffList,
  rectifyTargetUpdate, findExaminedMdg,
  getRectifyAddInfo
} from "@/api/processManager";
import { modulesList } from "@/api/model.js"
export default {
  name: "mainTargetAdd",
  data() {
    return {
      // 目标指标列表
      goalList: [],
      // 部门列表
      departList: [],
      // 公司领导列表
      companyLeaderList: [],
      // 标准列表
      standardList: [],
      // 人员的列表
      userList: [],
      // 整改负责人
      userList2: [],
      // 被考核部门领导
      userList3: [],
      typeList: [
        { id: 0, name: '年度目标' },
        { id: 1, name: '季度目标' },
        { id: 2, name: '月度目标' },
      ],
      tableData: [],
      // 表单数据
      ruleForm: {
        objIndChildId: '',
        indicatorNumber: '',
        abarbeitungDepId: '',
        abarbeitungDutyEmpId: '',
        abarbeitungCompletionTime: '',
        abarbeitungDepName: '',
        abarbeitungDutyName: '',
        reCheckDepId: '',
        reCheckEmpId: '',
        abarbeitungContent: '',
        fileName: '',
        fileUrl: ''
      },
      rules: {
        indicatorNumber: [{ required: true }],
        abarbeitungDepId: [{ required: true }],
        abarbeitungDutyEmpId: [{ required: true, message: '请选择整改负责人' }],
        abarbeitungCompletionTime: [{ required: true, message: '请选择整改期限' }],
        reCheckDepId: [{ required: true, message: '请选择复核部门' }],
        reCheckEmpId: [{ required: true, message: '请选择复核负责人' }],
        abarbeitungContent: [{ required: true, message: '请输入整改内容' }],
        definitionId: [{ required: true, message: '请选择' }]
      },
      tableData: [],
      // 文件上传的东西
      fileList: [],
      modules: []
    };
  },
  created() {
    this.getDepart();
    this.getCompanyLeader();
    this.getModulesList()
    // 编辑
    if(this.$route.params.id) {
      let obj = { ...this.$route.params }
      if(obj.fileName !== '' && obj.fileName !== 'null' && obj.fileUrl !== '' && obj.fileUrl !== 'null') {
        let fileObj = {
          name: obj.fileName,
          response: {
            data: obj.fileUrl
          }
        }
        this.fileList.push(fileObj)
      }
      delete(obj.gmtCreate)
      delete(obj.reCheckContent)
      delete(obj.reCheckTime)
      this.ruleForm = obj
      // this.tableData = JSON.parse(obj.examinedContent)
      getDepartUser({ demId: obj.reCheckDepId }).then(res => {
        this.userList = res.body.data;
      })
      getDepartUser({ demId: obj.abarbeitungDepId }).then(res => {
        this.userList2 = res.body.data;
      })
    }
    // 从考核列表跳转过来
    if(this.$route.query.jumpStatus) {
      this.ruleForm.objIndChildId = this.$route.query.id
      getRectifyAddInfo({ objIndChildId: this.$route.query.id }).then(res => {
        console.log(res);
        let obj2 = res.body.data
        this.ruleForm.abarbeitungDepId = obj2.abarbeitungDepId
        this.ruleForm.abarbeitungDepName = obj2.abarbeitungDepName
        this.ruleForm.abarbeitungDutyEmpId = obj2.abarbeitungDutyEmpId
        this.ruleForm.abarbeitungDutyName = obj2.abarbeitungDutyName
        this.ruleForm.indicatorNumber = obj2.indicatorNumber
        getDepartUser({ demId: res.body.data.abarbeitungDepId }).then(res => {
          this.userList2 = res.body.data;
        })
      })
    }
  },
  methods: {
    // 获取所有部门
    getDepart() {
      getAllDepartment().then(res => {
        this.departList = res.body.data;
      })
    },
    // 获取公司领导列表
    getCompanyLeader() {
      getStaffList({}).then(res => {
        this.companyLeaderList = res.body.data
      })
    },
    // 选择指标后调取接口
    goalSelectChange(id) {
      getGoalAddData({ objectiveIndicatorId: id }).then(res => {
        let obj = res.body.data
        this.ruleForm.completionDate = obj.completionDate;
        this.ruleForm.type = obj.type;
        this.ruleForm.objectiveContent = obj.objectiveContent;
        this.ruleForm.objectiveExplain = obj.objectiveExplain;
        this.ruleForm.year = obj.year;
        this.ruleForm.indicatorNumber = obj.indicatorNumber
        this.$forceUpdate()
      })
    },
    // 部门改变
    departChange(id) {
      let obj = this.departList.find((item => {
        return item.id === id
      }))
      this.ruleForm.reCheckEmpId = ''
      this.ruleForm.reCheckDepName = obj.name
      this.getUser(id);
      this.$forceUpdate()
    },
    user(id, status) {
      let obj = this.userList.find((item => {
        return item.id === id
      }))
      if(status === 1) {
        this.ruleForm.reCheckEmpName = obj.name
      }
      // if(status === 2) {
      //   this.ruleForm.departmentHeadName = obj.name
      // }
      // if(status === 3) {
      //   let obj2 = this.userList3.find((item => {
      //     return item.id === id
      //   }))
      //   this.ruleForm.targetEmpName = obj2.name
      // }
      // if(status === 4) {
      //   let obj3 = this.companyLeaderList.find((item => {
      //     return item.id === id
      //   }))
      //   this.ruleForm.companyLeaderName = obj3.name
      // }
      this.$forceUpdate();
    },
    // 获取部门下面的人员
    getUser(id) {
      getDepartUser({ demId: id }).then(res => {
        // this.ruleForm.departmentHeadEmpid = ''
        // this.ruleForm.producerEmpId = ''
        this.userList = res.body.data;
      })
    },
    // 文件上传的东西
      handleRemove(file, fileList) {
        this.fileList = fileList
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件`);
      },
      handleChange(files, fileList) {
        this.fileList = fileList
      },
    // 表格里面输入框改变的事件
    inpChange(row) {
      if(Number(row.Scoring) > Number(row.score)) {
        this.$message.warning('评分不能超过最大得分数')
        row.Scoring = ''
      }
    },
    // 评分框失焦算总分
    inpBlur() {
      let score = 0
      for(let i in this.tableData) {
        score += Number(this.tableData[i].Scoring)
      }
      this.ruleForm.examinationScore = score
    },
    getModulesList() {
      modulesList().then(res => {
        this.modules = res.body.data
      }) 
    },

    // 模板更改
    modelChange(a) {
      let obj = {}
      obj = this.modules.find(v => {
        return a === v.definitionId
      })
      this.ruleForm.key = obj.key
      // console.log(this.form)
    },
    // 保存的按钮
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let obj = {...this.ruleForm}
          if(this.fileList.length > 0) {
            obj.fileName = this.fileList[0].name
            obj.fileUrl = this.fileList[0].response.data
          }else{
            obj.fileName = "",
            obj.fileUrl = ""
          }
          obj.examinedContent = JSON.stringify(this.tableData);
          if(this.$route.params.id) {
            rectifyTargetUpdate({...obj}).then(res => {
              this.$message.success('编辑成功');
              this.$router.back();
            })
          }else{
            rectifyTargetSave({...obj}).then(res => {
              this.$message.success('添加成功');
              this.$router.push('rectifyTarget');
            })
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.formBox {
  padding-top: 15px;
  padding-right: 10%;
  width: 70%;
  margin: auto;
}
.formBox /deep/ .el-form-item {
  margin-bottom: 25px;
}
</style>